import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../environment/environment';
import { ServiceCase } from './model/service-case';
import { ServiceCaseStatus } from './enum/service-case-status.enum';
import { PageResult } from '../../common/model/PageResult';
import { ServiceCaseQuery } from './model/service-case-query';

@Injectable({
  providedIn: 'root',
})
export class ServiceCaseService {
  // URL to the mock data file (for development/testing); replace with actual API endpoint
  private serviceCasesUrl = '/mock-data/recent-service-case.json';
  private serviceCaseServiceEndpoint = environment.APIBase + 'Incident'; // Base URL for the delivery note service

  constructor(private httpContext: HttpClient) {}

  /**
   * Fetches recent delivery notes from the mock data source.
   * @returns A promise that resolves with an array of ServiceCase objects.
   */
  public getRecentServiceCases(): Promise<ServiceCase[]> {
    return new Promise<ServiceCase[]>((resolve, reject) => {
      this.httpContext
        .get(this.serviceCasesUrl)
        .pipe(map((res) => res as ServiceCase[])) // Map response to ServiceCase array
        .subscribe(
          (res: ServiceCase[]) => {
            resolve(res); // Resolve with the fetched delivery notes
          },
          (error) => {
            console.error('Error in get recent ServiceCases', error); // Log error
            reject(error); // Reject promise with error
          },
        );
    });
  }

  /**
   * Retrieves a paginated list of delivery notes based on the provided query parameters.
   * @param serviceCaseQuery - A ServiceCaseQuery object containing query parameters for filtering and pagination.
   * @returns A promise that resolves with a ServiceCase[] containing the paginated delivery notes and pagination details.
   */
  public getCustomerIncidents(serviceCaseQuery:ServiceCaseQuery): Promise<PageResult<ServiceCase>> {
    return new Promise<PageResult<ServiceCase>>((resolve, reject) => {
      this.httpContext
        .post(this.serviceCaseServiceEndpoint + '/customerIncidents/query',serviceCaseQuery)
        .pipe(map((res) => res as PageResult<ServiceCase>)) // Map response to ServiceCase[]
        .subscribe(
          (res: PageResult<ServiceCase>) => {
            resolve(res); // Resolve with the paginated delivery notes
          },
          (error) => {
            console.error('Error in getServiceCases', error); // Log error
            reject(error); // Reject promise with error
          },
        );
    });
  }

    /**
   * Retrieves a paginated list of delivery notes based on the provided query parameters.
   * @param serviceCaseQuery - A ServiceCaseQuery object containing query parameters for filtering and pagination.
   * @returns A promise that resolves with a ServiceCase[] containing the paginated delivery notes and pagination details.
   */
    public getUserIncidents(serviceCaseQuery:ServiceCaseQuery): Promise<PageResult<ServiceCase>> {
      return new Promise<PageResult<ServiceCase>>((resolve, reject) => {
        this.httpContext
          .post(this.serviceCaseServiceEndpoint + '/userIncidents/query',serviceCaseQuery)
          .pipe(map((res) => res as PageResult<ServiceCase>)) // Map response to PageResult<ServiceCase>
          .subscribe(
            (res: PageResult<ServiceCase>) => {
              resolve(res); // Resolve with the paginated delivery notes
            },
            (error) => {
              console.error('Error in getServiceCases', error); // Log error
              reject(error); // Reject promise with error
            },
          );
      });
    }


  /**
   * Determines the severity level based on the delivery note status.
   * @param status - The current status of the delivery note
   * @returns The severity level as a string union type
   */
  public getServiceCaseStatusSeverity(
    status: ServiceCaseStatus | null,
  ):
  | 'success'
  | 'secondary'
  | 'info'
  | 'warn'
  | 'danger'
  | 'contrast'
    | undefined {
    if (status == ServiceCaseStatus.New || status == ServiceCaseStatus.AwaitingInfo) {
      return 'info';
    } else if (status == ServiceCaseStatus.Open) {
      return 'warn';
    } else if (status == ServiceCaseStatus.Resolved) {
      return 'success';
    } else if (status == ServiceCaseStatus.Closed) {
      return 'danger';
    }else if (status == ServiceCaseStatus.InProgress) {
      return 'warn';
    } else {
      return undefined; // Return undefined if status does not match any known cases
    }
  }
}
